module.exports = __webpack_public_path__ + "static/media/BirdHero.3ff1f549.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sprites/BirdHero.png
// module id = 287
// module chunks = 0